import { compose, mapProps } from 'recompose';
import { withStoreDetail } from './WithStoreDetail';

export const withExtractCurrency = compose(
  mapProps(({ store, ...props }) => ({
    currency: store.currency.code,
    ...props,
  })),
);

export const withCurrency = compose(
  withStoreDetail,
  withExtractCurrency,
);



// WEBPACK FOOTER //
// ./src/Common/Providers/WithCurrency.js